"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractCommand = void 0;
const ErrorBuilder_1 = require("../errors/ErrorBuilder");
class AbstractCommand {
    constructor(api) {
        this.execute = async () => {
            try {
                return await this.exec();
            }
            catch (error) {
                if (error.response) {
                    throw ErrorBuilder_1.ErrorBuilder.forResponse(error.response).build();
                }
                throw error;
            }
        };
        this.api = api;
    }
}
exports.AbstractCommand = AbstractCommand;
//# sourceMappingURL=AbstractCommand.js.map